import { BookOpen } from "lucide-react";
import {
  headerButtonClassName,
  headerStackedToolClassName,
  headerToolClassName,
} from "@/components/layout/headerButtonClassName";
import { Button } from "@/components/ui/button";
import { useCourseGlossaryStore } from "@/stores/courseGlossaryStore";

export const GlossaryHeaderButton = () => {
  const isOpen = useCourseGlossaryStore((state) => state.isOpen);
  const openGlossary = useCourseGlossaryStore((state) => state.openGlossary);

  return (
    <Button
      variant="outline"
      size="sm"
      className={[
        "border-transparent text-primary-foreground",
        headerButtonClassName,
        headerStackedToolClassName,
        headerToolClassName(isOpen),
      ].join(" ")}
      onClick={() => openGlossary()}
    >
      <BookOpen className="size-4" />
      Glossar
    </Button>
  );
};
